import { useId, type ReactElement } from 'react';
import { Link } from 'react-router';
import { SectionHeading } from './SectionHeading';
import { USERS_PATH } from './paths';
import section from './Section.module.css';
import styles from './AdminNotFound.module.css';

/** Subcaminho desconhecido dentro da administração: continua na casca (cabeçalho e menu). */
export function AdminNotFound(): ReactElement {
  const headingId = useId();
  return (
    <section aria-labelledby={headingId} className={section.screen}>
      <SectionHeading id={headingId}>Página não encontrada</SectionHeading>
      <p className={section.lead}>Esta seção da administração não existe ou foi movida.</p>
      <Link to={USERS_PATH} className={styles.link}>
        Ir para Usuários
      </Link>
    </section>
  );
}
